export const stylesGlobalDefault = {
  backgroundListItemColor: "#ECF0F3",
  margintBottomList: "8px",
  inactivedItem: "#A9C3C9",
  activedItem: "#30CD82",
  blue: "#1D9BF0",
  titleNameColor: "#3E424E",
  subTitleNameColor: "#333333",
  titleMenuColor: "#7887A9",
  LabelColor: "#1A1A1A",
  blueDark: "#0D77BF",
  blueLight: "E4F1FA",
  blackMenu1: "#3e424e",
  blackMenu2: "#2b2e38",
  grey_disabled: "#7887A950",
  white: "#FFF",
  black: "#000000",
  gray: "#666666",
  gray2: "#8c8b8b",
  gray3: "#cbcbcb",
  grayLight: "#C8C8C8",
  green: "#4CAF50",
  inactivedButton: "rgba(120, 135, 169, 0.5)",
  inputsBorderFocusOff: "#d1dbe3",
  inputsBorderFocusError: "#EB5861",
  orange: "#E98D0B",
  fontFamily: "Inter",
};

export const colors = {
  default_blue: "#1D9BF0",
  default_dark_blue: "#0D77BF",
  default_label: "##666",
  default_hover_grey: "#7887A980",
  default_hover_light_grey: "#ECF0F3",
  default_disabled: "#7887A980",
  default_base_grey: "#D1DBE3",
  default_base_black_menu_1: "#3e424e",
  default_base_black: "#000000",
  default_base_orange: "#F2930D",
  default_base_white: "#FFFFFF",
  default_base_waiting: "#A9C3C9",
  default_base_success: "#30CD82",
  default_base_warning: "#F0CA68",
  default_base_notified: "#4778F5",
  default_base_error: "#EB5861",
  default_card_selected_blue: "#E4F1FA",
  background_primary: "#3E424E",
  background_secondary: "#2b2e38",
  // Style-guide (HyperVisual)
  primary_lighter: "#E4F1FA",
  primary_light: "#70C0F5",
  primary_default: "#1D9BF0",
  primary_dark: "#0D77BF",
  primary_darker: "#063C60",
  secundary_lighter: "#FFD599",
  secundary_light: "#FFAA33",
  secundary_default: "#F2930D",
  secundary_dark: "#CC7700",
  secundary_darker: "#663C00",
  neutral_black: "#000000",
  neutral_gray_10: "#1A1A1A",
  neutral_gray_20: "#333333",
  neutral_gray_40: "#666666",
  neutral_gray_60: "#999999",
  neutral_gray_70: "#B3B3B3",
  neutral_gray_80: "#CBCBCB",
  neutral_gray_90: "#E6E6E6",
  neutral_white: "#FFFFFF",
  general_link: "#1D9BF0",
  general_icons: "#7887A9",
  general_icons_disable: "#7887A980",
  background_lighter: "#ECF0F3",
  background_light: "#D1DBE3",
  background_dark: "#3E424E",
  background_darker: "#2B2E38",
  status_green: "#30CD82",
  status_yallow: "#F0CA68",
  status_red: "#EB5861",
  status_blue: "#4778F5",
  status_gray: "#A9C3C9",
};

export const globalStyle = {
  backgroundListItemColor: "#ECF0F3",
  margintBottomList: "8px",
  inactivedItem: "#A9C3C9",
  activedItem: "#30CD82",
  blue: "#1D9BF0",
  titleNameColor: "#3E424E",
  subTitleNameColor: "#333333",
  titleMenuColor: "#7887A9",
  LabelColor: "#1A1A1A",
  blueDark: "#0D77BF",
  blueLight: "E4F1FA",
  blackMenu1: "#3e424e",
  blackMenu2: "#2b2e38",
  grey_disabled: "#7887A950",
  white: "#FFF",
  black: "#000000",
  gray: "#666666",
  gray2: "#8c8b8b",
  gray3: "#cbcbcb",
  grayLight: "#C8C8C8",
  green: "#4CAF50",
  inactivedButton: "rgba(120, 135, 169, 0.5)",
  inputsBorderFocusOff: "#d1dbe3",
  inputsBorderFocusError: "#EB5861",
  orange: "#E98D0B",
  fontFamily: '"Inter", "Courier New", Courier, monospace',
  labelColor: colors.default_label,
  headers: {
    background: {
      primary: colors.background_primary,
      secondary: colors.background_secondary,
    },
  },
  input: {
    default: colors.default_base_grey,
    hover: colors.default_hover_grey,
    focus: colors.default_blue,
    error: colors.default_base_error,
  },
  button: {
    default: colors.default_blue,
    disabled: colors.default_disabled,
  },
  toast: {
    success: colors.default_base_success,
    warning: colors.default_base_warning,
    error: colors.default_base_error,
  },
  card: {
    color: {
      default_color: colors.default_hover_light_grey,
      selected: colors.default_card_selected_blue,
    },
    border: {
      default_color: colors.default_hover_light_grey,
      hover: colors.default_blue,
      selected: colors.default_blue,
    },
  },
  badge: {
    waiting: colors.default_base_waiting,
    success: colors.default_base_success,
    warning: colors.default_base_warning,
    notified: colors.default_base_notified,
    error: colors.default_base_error,
    inactive: colors.default_base_waiting,
  },
};
